import { useMutation } from 'react-query';
import http from '@framework/utils/http';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
interface FeedbackData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  message: string;
}
const sendFeedback = async (data: FeedbackData) => {
  const response = await http.post(API_ENDPOINTS.FEEDBACK, data);
  return response.data;
};
export const useFeedback = () => {
  return useMutation(sendFeedback, {});
};